import {PageHeader} from "@/layout/components/PageHeader.tsx";
import {PageWrapper} from "@/layout/components/PageWrapper.tsx";
import {PaymentMethod} from "@/pages/system-payment-method/components/PaymentMethod.tsx";
import {useCurrentSystem} from "@/hooks/useCurrentSystem.tsx";
import {Navigate} from "react-router";
import {toast} from "sonner";

export function SystemPaymentMethod() {

    const {role} = useCurrentSystem();

    if(role && role !== 1) {
        toast.info('רק בעלים יכול לנהל את פרטי התשלום')
        return (
            <Navigate to="/" replace={true} state={{from: '/system/payment-method'}} />
        );
    }

    return (
        <PageWrapper>
            <PageHeader title="פרטי תשלום"/>

            <div className="grid gap-8">
                <PaymentMethod/>
            </div>
        </PageWrapper>
    )
}